@if (days(); as list) {
  <div class="stock-days">
    @for (day of list; track day.label) {
      <div class="stock-day">
        <span class="stock-day__label">{{ day.label }}</span>
        <span class="stock-day__bar">
          <span [class]="'stock-day__fill ' + fillClass(day)" [style.width.%]="fillPercent(day)"></span>
        </span>
        <span class="stock-day__value" [class.muted]="day.stock === null">
          {{ day.stock === null ? '—' : day.stock }}
        </span>
      </div>
    }
  </div>
} @else {
  <span class="no-stock">No stock — not offered yet</span>
}
